import { SVGProps } from 'react';

const Ruler = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 298 51'
    width='100%'
    height={51}
    preserveAspectRatio='none'
    fill='none'
    {...props}
  >
    <g stroke='#B7C5D9' strokeLinecap='round' strokeWidth={2} opacity={0.5}>
      <path d='M1 51.075V28.819M18 51.075V12.128M34 51.075V28.819M51 51.075V1M51 51.075V1M67 51.075V28.819M83 51.075V12.128M100 51.075V28.819M116 51.075V1M116 51.075V1M133 51.075V28.819M149 51.075V12.128M165 51.075V28.819M182 51.075V1M182 51.075V1M198 51.075V28.819M215 51.075V12.128M231 51.075V28.819M247 51.075V1M247 51.075V1M264 51.075V28.819M280 51.075V12.128M297 51.075V28.819' />
    </g>
  </svg>
);
export default Ruler;
